// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"SkeletonStyles_skeleton__qyRVz","pulse":"SkeletonStyles_pulse__EWpA3","shimmer":"SkeletonStyles_shimmer__7cA8w"};